import { InMemoryCache, makeVar } from '@apollo/client';
export var apolloCache = new InMemoryCache({});
export var UISettingsVar = makeVar({ isMobile: false, sidebarIsOpen: true });
